import { createRoot, createSignal } from "solid-js";

/** A shared 1 Hz clock for countdowns and "x ago" labels. */
export const now = createRoot(() => {
  const [t, setT] = createSignal(Date.now());
  setInterval(() => setT(Date.now()), 1000);
  return t;
});
